import Image from 'next/image'
import { CheckIcon } from '@components/icons/CheckIcon'
import { StatusProps } from './interface'

export function Status({
  price,
  isPaid,
  isRestricted,
  isFree,
  sellingPrice,
  hasChapterCampaign,
}: StatusProps) {
  if (isPaid) {
    return (
      <div className='flex items-center space-x-[6px]'>
        <CheckIcon className='text-primary' width='18' height='18' />
        <span className='font-bold text-secondary-1 whitespace-nowrap'>
          ซื้อแล้ว
        </span>
      </div>
    )
  }

  if (isRestricted) {
    return (
      <div className='font-bold text-secondary-1 whitespace-nowrap'>
        เนื้อหาถูกปิด
      </div>
    )
  }

  if (isFree) {
    return (
      <div className='flex items-center space-x-[6px]' data-test='buy-chapter'>
        <div className='flex items-center shrink-0'>
          <Image src='/coin.webp' width='18' height='18' />
        </div>
        <div className='font-bold text-coin'>ฟรี</div>
      </div>
    )
  }

  if (price && !isPaid) {
    return (
      <div className='flex items-center' data-test='buy-chapter'>
        {hasChapterCampaign && sellingPrice >= 0 ? (
          <div className='flex flex-col items-end'>
            <div className='flex flex-row items-center space-x-2'>
              <div className='flex items-center shrink-0'>
                <Image src='/coin.webp' width='18' height='18' />
              </div>
              <div className='text-coin'>{sellingPrice.toLocaleString()}</div>
              <div className='line-through opacity-50 text-secondary-1'>
                {price.toLocaleString()}
              </div>
            </div>
          </div>
        ) : (
          <div className='flex items-center space-x-[6px]'>
            <div className='flex items-center shrink-0'>
              <Image src='/coin.webp' width='18' height='18' />
            </div>
            <div className='font-bold text-coin'>{price.toLocaleString()}</div>
          </div>
        )}
      </div>
    )
  }

  return null
}
